
export const PAYMENT_METHOD = [
    "Efectivo",
    "Transferencia",
]